import { addLedgerExchange, getLedgerExchanges } from "@/api";

//
export default {
  namespaced: true,

  state: {
    ledgerExchanges: {},
    page: 1,
    limit: 50,
    sort: "-dateStart",
    searchString: "",
    balanceAcc: null,
    amountFrom: undefined,
    amountTo: undefined,
    creator: null,
    isDifferentDay: false,
    dateRange: null,
    dateType: "dateStart",
    onlyOpen: false,
    isFiltered: false,
    loading: true,
    queryTemplates: [
      {
        type: "operators",
        title: "Операторы",
        level: 1,
        query: {
          $and: [
            { $or: [{ isOpex: false }, { isOpex: { $exists: false } }] },
            {
              $or: [
                { isCorrection: false },
                { isCorrection: { $exists: false } }
              ]
            },
            {
              $or: [{ isBitzlato: false }, { isBitzlato: { $exists: false } }]
            },
            {
              $or: [{ isWhitebit: false }, { isWhitebit: { $exists: false } }]
            },
            { $or: [{ isInternal: false }, { isInternal: { $exists: false } }] },
            {
              $or: [
                { isReconciliation: false },
                { isReconciliation: { $exists: false } }
              ]
            }
          ]
        }
      },
      // {
      //   type: "bitzlato",
      //   title: "Bitzlato",
      //   level: 1,
      //   query: {
      //     isBitzlato: true
      //   }
      // },
      // {
      //   type: "whitebit",
      //   title: "WhiteBit",
      //   level: 1,
      //   query: {
      //     isWhitebit: true
      //   }
      // },
      {
        type: "internal",
        title: "Движения средств",
        level: 1,
        query: {
          isInternal: true
        }
      },
      {
        type: "opex",
        title: "Операционные расходы",
        level: 1,
        query: {
          isOpex: true
        }
      },
      {
        type: "corrections",
        title: "Корректировки",
        level: -1,
        query: {
          isCorrection: true
        }
      },
      {
        type: "reconciliations",
        title: "Реконсиляции",
        level: -1,
        query: {
          isReconciliation: true
        }
      }
    ],
    queryType: "operators"
  },

  mutations: {
    setLedgerExchanges(state, ledgerExchanges) {
      state.ledgerExchanges = ledgerExchanges;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setSearchString(state, searchString) {
      state.searchString = searchString;
    },
    setOnlyOpen(state, onlyOpen) {
      state.onlyOpen = onlyOpen;
    },
    setBalanceAcc(state, balanceAcc) {
      state.balanceAcc = balanceAcc;
    },
    setAmountFrom(state, amountFrom) {
      state.amountFrom = amountFrom;
    },
    setAmountTo(state, amountTo) {
      state.amountTo = amountTo;
    },
    setCreator(state, creator) {
      state.creator = creator;
    },
    setIsDifferentDay(state, isDifferentDay) {
      state.isDifferentDay = isDifferentDay;
    },
    setDateRange(state, dateRange) {
      state.dateRange = dateRange;
    },
    setDateType(state, dateType) {
      state.dateType = dateType;
    },
    setQueryType(state, queryType) {
      state.queryType = queryType;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async searchQueryBuilder(store) {
      if (
        !store.state.searchString &&
        !store.state.creator &&
        !store.state.isDifferentDay &&
        !store.state.onlyOpen &&
        !(store.state.dateRange && store.state.dateType)
      ) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "searchString",
          builder: () => {
            const q = {
              $or: [
                {
                  comment: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                },
                {
                  userName: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                }
              ]
            };
            if (
              store.state["searchString"].length === 12 ||
              store.state["searchString"].length === 24
            )
              q["$or"].push({ _id: store.state["searchString"] });
            return q;
          }
        },
        {
          state: "creator",
          builder: () => {
            return {
              creator: store.state["creator"]
            };
          }
        },
        {
          state: "onlyOpen",
          builder: () => {
            return {
              $or: [{ dateEnd: { $exists: false } }, { dateEnd: { $eq: null } }]
            };
          }
        },
        {
          state: "isDifferentDay",
          builder: () => {
            return {
              $expr: {
                $gt: [
                  {
                    $dateDiff: {
                      startDate: "$dateStart",
                      endDate: "$dateEnd",
                      unit: "day",
                      timezone: "+03"
                    }
                  },
                  0
                ]
              }
            };
          }
        },
        {
          state: "dateType",
          builder: () => {
            const value = {};
            if (!store.state.dateRange) return value;
            //
            value[store.state.dateType] = store.state.dateRange
              ? {
                  $lte: store.state.dateRange[1],
                  $gte: store.state.dateRange[0]
                }
              : null;
            //
            return value;
          }
        }
      ];
      const query = {
        $and: queryBuilders
          .filter(b => !!store.state[b.state])
          .map(b => b.builder())
      };

      store.commit("setIsFiltered", true);
      return query;
    },
    async getLedgerExchanges(store) {
      store.commit("setLoading", true);
      const queryTemplate = store.state.queryTemplates.find(
        template => template.type === store.state.queryType
      );
      // $or: [{comment: {$regex:".*ec.*", $options:"i"}}, {_id: {$regex:".*ec.*", $options:"i"}}]
      const queryBuilded = queryTemplate ? queryTemplate.query : {};
      const queryForSearch = await store.dispatch("searchQueryBuilder");
      // console.log(queryForSearch);
      const resp = await getLedgerExchanges({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort,
        balanceAcc: store.state.balanceAcc,
        amountFrom: store.state.amountFrom,
        amountTo: store.state.amountTo,
        query: { $and: [queryBuilded, queryForSearch] }
      });
      if (resp.data.status) {
        store.commit("setLedgerExchanges", resp.data.result);
        store.commit("setLoading", false);
        return resp.data.result;
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.ledgerExchanges.totalPages &&
        store.state.ledgerExchanges.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getLedgerExchanges");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getLedgerExchanges");
      }
    },
    async changeLimit(store, payload) {
      if (payload.limit !== undefined) {
        store.commit("setLimit", payload.limit);
        await store.dispatch("getLedgerExchanges");
      }
    },
    changeSearchString(store, payload) {
      if (payload.searchString !== undefined) {
        store.commit("setSearchString", payload.searchString);
      }
    },
    changeBalanceAcc(store, payload) {
      if (payload.balanceAcc !== undefined) {
        store.commit("setBalanceAcc", payload.balanceAcc);
      }
    },
    changeAmountFrom(store, payload) {
      // if (payload.amountFrom !== undefined) {
      store.commit("setAmountFrom", payload.amountFrom);
      // }
    },
    changeAmountTo(store, payload) {
      // if (payload.amountTo !== undefined) {
      store.commit("setAmountTo", payload.amountTo);
      // }
    },
    changeOnlyOpen(store, payload) {
      // if (payload.amountTo !== undefined) {
      store.commit("setOnlyOpen", payload.onlyOpen);
      // }
    },
    changeCreator(store, payload) {
      if (payload.creator !== undefined) {
        store.commit("setCreator", payload.creator);
      }
    },
    changeIsDifferentDay(store, payload) {
      if (payload.isDifferentDay !== undefined) {
        store.commit("setIsDifferentDay", payload.isDifferentDay);
      }
    },
    changeDateRange(store, payload) {
      if (payload.dateRange !== undefined) {
        store.commit("setDateRange", payload.dateRange);
      }
    },
    changeDateType(store, payload) {
      if (payload.dateType !== undefined) {
        store.commit("setDateType", payload.dateType);
      }
    },
    async performSearch(store, payload) {
      store.commit("setPage", 1);
      await store.dispatch("getLedgerExchanges");
    },
    async resetSearch(store, payload) {
      store.commit("setSearchString", "");
      store.commit("setCreator", null);
      store.commit("setIsDifferentDay", false);
      store.commit("setDateRange", null);
      store.commit("setDateType", null);
      store.commit("setOnlyOpen", false);
      await store.dispatch("getLedgerExchanges");
    },
    async changeQueryType(store, payload) {
      if (
        payload.queryType !== undefined &&
        store.state.queryTemplates.map(t => t.type).includes(payload.queryType)
      ) {
        store.commit("setQueryType", payload.queryType);
        await store.dispatch("getLedgerExchanges");
      }
    },
    // getSortedValutes(store) {
    //   return getValutes().then(response => {
    //     const valutes = response.data.result.sort((a, b) => {
    //       if (
    //         a.categories &&
    //         a.categories[0] &&
    //         a.categories[0].name === "Банки"
    //       ) {
    //         return -1;
    //       } else {
    //         return 1;
    //       }
    //     });
    //     valutes.map(valute => {
    //       store.dispatch("getValuteForms", valute._id);
    //     });
    //     //
    //     store.commit("setValutes", valutes);
    //     //
    //     return response;
    //   });
    // },

    async addLedgerExchange(store, ledgerExchange) {
      try {
        const resp = await addLedgerExchange(ledgerExchange);
        return resp.data;
      } catch (error) {
        console.log(error);
        return { status: false, error };
      }
    }

    // editValute(store, { id, valute }) {
    //   return editValute(id, valute).then(response => {
    //     store.dispatch("getValutes");
    //     //
    //     return response;
    //   });
    // },

    // deleteValute(store, id) {
    //   return deleteValute(id).then(response => {
    //     store.dispatch("getValutes");
    //     //
    //     return response;
    //   });
    // },

    // getValuteForms(store, id) {
    //   return getValuteForms(id).then(response => {
    //     store.commit("setValuteForms", { id, forms: response.data.result });
    //     //
    //     return response;
    //   });
    // },

    // addValuteForm(store, { valuteId, formData }) {
    //   return addValuteForm(valuteId, formData);
    // },

    // editValuteForm(store, { valuteId, formId, formData }) {
    //   return editValuteForm(valuteId, formId, formData);
    // },

    // deleteValuteForm(store, { valuteId, formId }) {
    //   return deleteValuteForm(valuteId, formId);
    // },

    // getValuteCategories(store) {
    //   return getValuteCategories().then(response => {
    //     store.commit("setCategories", response.data.result);
    //     //
    //     return response;
    //   });
    // },
    // getTradePairs(store) {
    //   return getTradePairs().then(response => {
    //     const tradePairs = response.data;
    //     //
    //     store.commit("setTradePairs", tradePairs);
    //     //
    //     return response;
    //   });
    // },

    // addTradePair(store, tradePair) {
    //   return addTradePair(tradePair).then(response => {
    //     store.dispatch("getTradePairs");
    //     //
    //     return response;
    //   });
    // },
    // deleteTradePair(store, id) {
    //   return deleteTradePair(id).then(response => {
    //     store.dispatch("getValutes");
    //     //
    //     return response;
    //   });
    // },
    // editTradePair(store, data) {
    //   return editTradePair(data).then(response => {
    //     store.dispatch("getValutes");
    //   });
    // }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerExchanges.js